import { render } from "./HeadlessLayout.vue?vue&type=template&id=1e1985e2&scoped=true"
import script from "./HeadlessLayout.vue?vue&type=script&lang=js"
export * from "./HeadlessLayout.vue?vue&type=script&lang=js"

import "./HeadlessLayout.vue?vue&type=style&index=0&id=1e1985e2&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1985e2"]])

export default __exports__